import React from 'react'
import Navbar from '../inc/Navbar';
import UpcomingEvents from './UpcomingEvents';


function UpcomingCourse() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
           


            <div className="mak">
                <div className="album py-2">
                    <div className="container">
                        <br />
                        <br />
                        <br />
                        <h1><b>MAK</b></h1>
                        <h6 className='taste'>Dare to unvail the unknown</h6>
                        <hr/>
                        <br />
                         
                    <h2>Upcoming <b>Events</b>
</h2>

                    </div>
                  
                </div>

            </div>
            <UpcomingEvents />
            <hr/>
          

        </div>
    )
}

export default UpcomingCourse